export default __webpack_public_path__ + "static/media/fuckies-exchange.c79940b0.png";